import { render, staticRenderFns } from "./SystemSettingsLayout.vue?vue&type=template&id=541fcd1c&scoped=true"
import script from "./SystemSettingsLayout.vue?vue&type=script&lang=js"
export * from "./SystemSettingsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541fcd1c",
  null
  
)

export default component.exports